import Bootstrap from 'bootstrap';

import Mmenu from 'mmenu-js';
import 'mhead-js';

import Swiper, { Navigation, Pagination, Autoplay, Lazy } from 'swiper';

import AOS from 'aos';

import {
    jarallax,
    jarallaxVideo
} from 'jarallax';

import PhotoSwipeLightbox from '../../node_modules/photoswipe/dist/photoswipe-lightbox.esm.min.js';
import PhotoSwipe from  '../../node_modules/photoswipe/dist/photoswipe.esm.min.js';

import flatpickr from "flatpickr";

import '../../node_modules/magnific-popup/dist/jquery.magnific-popup.min';

/**
 * JQuery Functions
 */
(function(uno) {

  uno(window.jQuery, window, document);

}(function($, window, document) {

  var templateFunctions = {

    init: function() {
      templateFunctions.mhead();
      templateFunctions.swiper();
      templateFunctions.jarallax();
      templateFunctions.aos();
      templateFunctions.calendar();
      templateFunctions.lazyload();
      templateFunctions.photoswipe();
      templateFunctions.magnificPopup();
    },

    mhead: function() {
      new Mhead(".navbar", {
        pin: 0,
        unpin: 0,
        tolerance: 5
      });
    },

    swiper: function() {
      var swiper = new Swiper(".swiper-fullscreen", {
        modules: [Navigation, Pagination],
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      var swiper = new Swiper(".swiper-villas", {
        modules: [Navigation, Pagination, Lazy],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        lazy: true,
        effect: "fade",
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      var swiper = new Swiper(".swiper-gallery", {
        modules: [Navigation, Pagination, Lazy],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        lazy: true,
        effect: "fade",
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      var swiper = new Swiper(".swiper-gallery-2", {
        modules: [Navigation, Pagination, Lazy],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        lazy: true,
        effect: "fade",
        keyboard: {
          enabled: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 2,
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      var swiper = new Swiper(".swiper-gallery-experiences", {
        modules: [Navigation, Pagination, Lazy],
        loop: true,
        slidesPerView: 2,
        spaceBetween: 10,
        lazy: true,
        effect: "fade",
        keyboard: {
          enabled: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

    },

    photoswipe: function() {

      // get all <a> elements inside <figure> elements
      const atags = Array.from(document.querySelectorAll('.gallery-image-container a'));
      // iterate over every <a> tag
      atags.forEach(atag => {
          // create blank image element
          var img = new Image();
          // when the image loads, store its dimensions to the atag's
          // `data-original-size` attribute
          img.addEventListener('load', () => {
              let imgW = img.width,
              imgH = img.height;
              atag.dataset.pswpWidth = `${imgW}`;
              atag.dataset.pswpHeight = `${imgH}`;
          });
          // load image from atag's href
          img.src = atag.href;
      });
      
      const lightbox = new PhotoSwipeLightbox({
        gallery: '#pswpgallery',
        children: 'a',
        pswpModule: PhotoSwipe,
        paddingFn: (viewportSize) => {
          return {
            top: 30, bottom: 30, left: 70, right: 70
          }
        }
      });

      lightbox.init();
    },

    jarallax: function() {
        jarallaxVideo();
        jarallax(document.querySelectorAll('.jarallax'), {
            speed: 0.25
        });
    },

    calendar: function() {
      flatpickr("#requested-setup-datetime", {
        enableTime: true,
        altFormat: "F j, Y",
        dateFormat: "d-m-Y - h:iK",
        minDate: new Date().fp_incr(5)
      });

      flatpickr(".flatpickr-range", {
        minDate: new Date().fp_incr(5),
        mode: "range",
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "d-m-Y",
        wrap: true
      });

      flatpickr(".flatpickr", {
        minDate: "today",
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "d-m-Y",
        wrap: true
      });
      },

    aos: function() {
      AOS.init({
        duration: 1200,
      }) 
    },

    lazyload: function() {
      if ("loading" in HTMLImageElement.prototype) {
        const images = document.querySelectorAll("img.lazyload");
        images.forEach((img) => {
          img.src = img.dataset.src;
        });
      } else {
        let script = document.createElement("script");
        script.async = true;
        script.src =
          "https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.3.2/lazysizes.min.js";
        document.body.appendChild(script);
      }
    },

    magnificPopup: function () {
      $('.gallery-item').magnificPopup({
        type: 'image',
        gallery: {
          enabled:true,
          navigateByImgClick: true,
          preload: [1,2]
        }
      });
    }
  };

  $(function() {
    templateFunctions.init();
  });

}));
